var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _circle, _circle2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOptimizeRightImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 536,
    height: 536,
    viewBox: "0 0 536 536",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.724 470.951C227.71 470.951 298.432 524.297 348.057 524.297C397.682 524.297 501.904 495.755 501.904 267.464C501.904 39.1727 361.695 5.67267 307.113 5.67267C51.5151 5.67267 -57.6651 470.951 124.724 470.951Z",
    fill: "url(#paint0_linear_4596_14839)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.722 390.833H130.278C113.826 390.833 100.5 377.508 100.5 361.056V145.167C100.5 128.714 113.826 115.389 130.278 115.389H405.722C422.174 115.389 435.5 128.714 435.5 145.167V361.056C435.5 377.508 422.174 390.833 405.722 390.833Z",
    fill: "url(#paint1_linear_4596_14839)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 361.056V145.167C134 128.714 147.326 115.389 163.778 115.389H130.278C113.826 115.389 100.5 128.714 100.5 145.167V361.056C100.5 377.508 113.826 390.833 130.278 390.833H163.778C147.326 390.833 134 377.508 134 361.056Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.999 316.389C298.835 316.389 323.833 291.391 323.833 260.556C323.833 229.72 298.835 204.722 267.999 204.722C237.163 204.722 212.166 229.72 212.166 260.556C212.166 291.391 237.163 316.389 267.999 316.389Z",
    fill: "#2FDF84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.666 260.556C245.666 235.602 262.148 214.713 284.749 207.566C279.434 205.884 273.88 204.722 267.999 204.722C237.164 204.722 212.166 229.721 212.166 260.556C212.166 291.39 237.164 316.389 267.999 316.389C273.88 316.389 279.434 315.228 284.749 313.545C262.148 306.398 245.666 285.509 245.666 260.556Z",
    fill: "#00B871"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352.688 435.738H322.91V450.627H352.688V435.738Z",
    fill: "#ADEEDD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M438.299 435.738H408.521V450.627H438.299V435.738Z",
    fill: "#ADEEDD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M386.188 472.96H371.299V502.738H386.188V472.96Z",
    fill: "#ADEEDD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M405.723 402H130.278C107.692 402 89.334 383.642 89.334 361.056V145.167C89.334 122.595 107.692 104.222 130.278 104.222H405.723C428.309 104.222 446.667 122.595 446.667 145.167V361.056C446.667 383.642 428.309 402 405.723 402ZM130.278 126.556C120.02 126.556 111.667 134.893 111.667 145.167V361.056C111.667 371.314 120.02 379.667 130.278 379.667H405.723C415.981 379.667 424.334 371.314 424.334 361.056V145.167C424.334 134.908 415.981 126.556 405.723 126.556H130.278Z",
    fill: "#AEEEDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268 327.556C231.061 327.556 201 297.495 201 260.556C201 223.616 231.061 193.556 268 193.556C304.939 193.556 335 223.616 335 260.556C335 297.51 304.939 327.556 268 327.556ZM268 215.889C243.374 215.889 223.333 235.929 223.333 260.556C223.333 285.182 243.374 305.222 268 305.222C292.626 305.222 312.667 285.182 312.667 260.556C312.667 235.929 292.626 215.889 268 215.889Z",
    fill: "#ADEEDD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279.167 160.056H256.834V204.722H279.167V160.056Z",
    fill: "#ADEEDD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M214.462 278.729L176.219 299.091L186.715 318.804L224.958 298.442L214.462 278.729Z",
    fill: "#ADEEDD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M321.541 278.739L311.047 298.453L349.292 318.812L359.787 299.098L321.541 278.739Z",
    fill: "#ADEEDD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.222 390.833H148.889V420.611H171.222V390.833Z",
    fill: "#ADEEDD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M387.113 390.833H364.779V420.611H387.113V390.833Z",
    fill: "#ADEEDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4596_14839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268 299.088C289.314 299.088 306.592 281.81 306.592 260.496C306.592 239.182 289.314 221.904 268 221.904C246.686 221.904 229.408 239.182 229.408 260.496C229.408 281.81 246.686 299.088 268 299.088Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.102 288.344C257.102 288.344 260.595 285.942 268.023 285.942C275.451 285.942 278.946 288.344 278.946 288.344C278.946 288.344 277.927 289.635 276.703 290.02C275.479 290.406 273.849 290.044 271.81 291.493C269.771 292.943 268.023 292.785 268.023 292.785C268.023 292.785 266.276 292.94 264.238 291.493C262.2 290.047 260.567 290.405 259.343 290.02C258.119 289.636 257.102 288.344 257.102 288.344Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.435 236.219C263.324 236.103 260.329 236.356 258.538 235.72C255.48 234.639 254.988 233.545 252.399 234.088C250.51 234.485 250.06 235.965 249.874 237.47C254.455 236.648 257.08 237.711 257.08 237.711C250.496 238.414 248.265 240.195 248.126 240.306C247.952 240.462 247.808 240.648 247.699 240.854C247.486 241.306 247.651 241.472 247.689 242.364C256.837 239.585 264.145 241.515 264.145 241.515C257.476 241.669 251.241 242.829 245.275 245.726L246.152 248.796C251.638 246.819 254.725 248.227 254.725 248.227C251.447 249.017 248.287 250.236 245.328 251.851L245.891 253.275C244.619 254.252 243.575 257.898 243.575 257.898C243.267 255.927 244.502 253.208 244.502 253.208C241.919 253.363 240.951 255.814 240.951 257.853C240.951 259.892 242.259 262.194 243.844 263.691C245.429 265.189 245.792 266.841 245.792 266.841C246.995 263.554 244.659 263.29 245.295 259.386C245.931 255.482 250.618 253.406 250.618 253.406C249.655 253.194 248.679 253.054 247.696 252.988C249.713 252.679 251.126 249.446 263.625 257.566C276.124 265.686 283.864 257.472 288.015 254.987C289.25 255.995 290.54 257.472 290.852 259.386C291.487 263.284 289.154 263.554 290.354 266.841C290.354 266.841 290.716 265.187 292.302 263.691C293.887 262.196 295.202 259.885 295.202 257.847C295.202 255.809 294.228 253.361 291.644 253.202C291.644 253.202 292.891 255.921 292.57 257.892C292.57 257.892 291.49 254.11 290.181 253.218L290.868 251.486L290.23 251.032C281.331 245.637 268.024 245.831 268.024 245.831C280.914 244.698 290.015 248.854 290.015 248.854L290.773 245.737L288.439 244.596C288.439 244.596 288.541 242.372 288.155 241.555C287.928 241.073 287.266 240.599 286.766 240.292C281.917 238.164 273.575 237.711 273.575 237.711C281.002 237.024 284.69 237.483 286.176 237.79C285.919 236.225 285.25 233.915 283.572 233.562C282.473 233.33 281.751 233.394 281.048 233.628C280.74 233.275 279.784 232.247 278.671 231.896C277.319 231.47 275.516 231.87 273.268 230.268C271.021 228.665 269.082 228.841 269.082 228.841C269.082 228.841 267.151 228.667 264.897 230.269C262.643 231.872 260.84 231.472 259.494 231.898C258.148 232.324 257.015 233.75 257.015 233.75C257.015 233.75 259.73 235.615 265.446 236.22L265.435 236.219Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.024 284.698C268.024 284.698 261.679 284.721 258.62 285.808C255.56 286.894 255.069 287.983 252.48 287.439C250.589 287.041 250.188 285.371 250.001 283.864C254.583 284.689 257.079 283.292 257.079 283.292C250.495 282.588 248.265 280.806 248.126 280.697C247.952 280.541 247.807 280.355 247.698 280.149C247.485 279.695 247.556 279.392 247.595 278.501C256.744 281.277 264.141 279.483 264.141 279.483C257.473 279.329 251.238 278.17 245.271 275.272L246.181 271.862C251.892 273.295 254.717 272.776 254.717 272.776C251.44 271.988 248.281 270.77 245.322 269.156L246.042 267.342C255.284 271.112 280.756 271.112 289.998 267.342L290.859 269.517L290.23 269.97C281.33 275.372 268.024 275.178 268.024 275.178C280.914 276.311 290.015 272.155 290.015 272.155L290.773 275.272L288.439 276.405C288.439 276.405 288.734 279.327 288.348 280.144C288.121 280.624 287.459 281.098 286.959 281.405C282.11 283.535 273.575 283.29 273.575 283.29C281.001 283.977 284.632 284.054 286.113 283.753C285.855 285.318 285.254 287.091 283.572 287.446C280.988 287.989 280.484 286.902 277.431 285.814C274.378 284.726 268.027 284.704 268.027 284.704L268.024 284.698Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.223 259.791C254.223 259.791 253.042 262.629 255.356 263.762C257.67 264.895 263.482 264.323 263.482 264.323C263.482 264.323 258.444 260.609 254.22 259.791H254.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M283.025 262.705C283.025 262.705 283.477 265.061 281.529 265.559C279.581 266.058 275.23 264.699 275.23 264.699C275.23 264.699 279.67 262.657 283.025 262.705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.298 245.868C291.298 245.868 295.704 246.157 298.387 247.66C300.713 248.962 302.978 251.959 302.978 251.959C302.978 251.959 299.654 253.006 298.62 254.222C297.671 255.343 297.475 255.851 297.475 255.851C297.475 255.851 295.017 250.876 290.59 249.048L291.298 245.868Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 286.993C284 286.993 286.183 288.906 288.129 289.463C289.817 289.939 292.263 289.599 292.263 289.599C292.263 289.599 291.204 287.567 291.289 286.521C291.368 285.558 291.513 285.23 291.513 285.23C289.656 284.974 287.84 284.478 286.11 283.755L284 286.993Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.276 266.936C245.276 266.936 241.955 269.848 238.994 270.684C236.429 271.407 232.707 270.89 232.707 270.89C232.707 270.89 234.319 267.798 234.194 266.208C234.073 264.744 233.852 264.246 233.852 264.246C233.852 264.246 239.109 266.027 243.531 264.188L245.276 266.936Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.731 233.466C256.731 233.466 254.271 231.663 253.264 229.791C252.392 228.17 252.184 225.581 252.184 225.581C252.184 225.581 254.51 226.199 255.564 225.879C256.534 225.578 256.836 225.356 256.836 225.356C256.836 225.356 256.423 229.167 258.321 231.875L256.731 233.466Z",
    fill: "#03F5AE"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 32,
    r: 32,
    fill: "url(#paint2_linear_4596_14839)",
    fillOpacity: 0.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 162,
    r: 20,
    fill: "url(#paint3_linear_4596_14839)",
    fillOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4596_14839",
    x1: 104.267,
    y1: 22.9602,
    x2: 548.605,
    y2: 478.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4596_14839",
    x1: 268,
    y1: 115.389,
    x2: 268,
    y2: 390.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FA28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001E15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4596_14839",
    x1: 481.6,
    y1: 2.13333,
    x2: 536,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4596_14839",
    x1: 31,
    y1: 143.333,
    x2: 65,
    y2: 182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4596_14839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.184,
    height: 77.184,
    fill: "white",
    transform: "translate(229.408 221.904)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimizeRightImg);
export default __webpack_public_path__ + "static/media/optimize-right-img.bdb7f38d02069b4cc76aa13e3565f94b.svg";
export { ForwardRef as ReactComponent };